<template>
  <div>
    <section-header
      ref="selectHeader"
      title="Calculated Statistics"
    ></section-header>
    <div
      v-if="selectionModel.selectedStatistics.sampleSize"
      class="col-xs-offset-1"
    >
      Sample Size
    </div>
    <div
      v-if="selectionModel.selectedStatistics.chiSquare"
      class="col-xs-offset-1"
    >
      Chi Square / Degrees of Freedom /p-value
    </div>
    <div
      v-if="selectionModel.selectedStatistics.rowPercentage"
      class="col-xs-offset-1"
    >
      Row Percentage
    </div>
    <div
      v-if="selectionModel.selectedStatistics.columnPercentage"
      class="col-xs-offset-1"
    >
      Column Percentage
    </div>
    <div
      v-if="selectionModel.selectedStatistics.totalPercentage"
      class="col-xs-offset-1"
    >
      Total Percentage
    </div>
    <div>
      <h4 class="the-header col-xs-12">Select Additional Statistics</h4>
    </div>
    <ul class="list-group checked-list-box">
      <li class="checkbox">
        <label
          ><input
            type="checkbox"
            v-model="selectionModel.selectedStatistics.standardError"
            v-focus
          />Standard Error</label
        >
      </li>
      <li class="checkbox">
        <label
          ><input
            type="checkbox"
            v-model="selectionModel.selectedStatistics.confidenceInterval"
          />95% Confidence Interval</label
        >
      </li>
    </ul>

    <div>
      <h4 class="the-header col-xs-12">Other</h4>
    </div>
    <ul class="list-group checked-list-box no-bottom-margin">
      <li class="checkbox">
        <label>
          <input
            type="checkbox"
            v-model="selectionModel.selectedStatistics.weightedN"
            :disabled="moreThanOneYear"
          />Include Weighted N</label
        >
      </li>
      <li class="checkbox">
        <label
          ><input
            type="checkbox"
            v-model="selectionModel.selectedStatistics.nonResponse"
          />Include Non Response Categories</label
        >
      </li>
    </ul>
    <app-navigator
      ref="appNavigator"
      :router="$router"
      nextButtonValue="Run Report"
    ></app-navigator>
  </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import current from "@/scripts/current";
import commonModelHelper from "@/scripts/commonModelHelper";
import sectionHeader from "@/components/sub/sectionHeader";
import store from "@/store";
import appNavigator from "@/components/layout/appNavigator";

export default {
  components: {
    // <my-component> will only be available in parent's template
    sectionHeader,
    appNavigator,
  },
  created: function () {},
  data: function () {
    var vm = this;
    current.initializeCrossTabulationValues(vm);
    commonModelHelper.initializeStep(vm, "statistics");
    var selectionModel = current.selectionModel;
    var omittedVariables = commonModelHelper.getSelectedVariables(
      selectionModel,
      ["row", "column", "control1", "control2"]
    );
    var statistics = [
      { property: "rowPercentage", display: "Row Percentage" },
      { property: "columnPercentage", display: "Column Percentage" },
      { property: "totalPercentage", display: "Total Percentage" },
      { property: "weightedN", display: "Weighted N" },
    ];
    var moreThanOneYear = store.state.selModel.years.selectionType !== "single";
    if (moreThanOneYear) {
      selectionModel.selectedStatistics.weightedN = false;
    }
    return {
      modelHelper: current.modelHelper,
      selectionModel,
      statistics,
      omittedVariables,
      moreThanOneYear,
    };
  },
  methods: {},
};
</script>

<style scoped>
.spaced-out {
  margin-top: 20px;
  margin-bottom: 20px;
}

.dropdown-menu label.radio input[type="radio"] {
  visibility: hidden;
}

.dropdown-menu label.radio {
  padding-left: 10px;
}

.no-bottom-margin {
  margin-bottom: 0px;
}

li.checkbox {
  list-style: none;
  line-height: 25px;
  margin: 10px 0;
}

h4 {
  font-weight: 400;
}
</style>
